export default function (props: any) {
    return (
        <svg
            width="64px"
            height="64px"
            viewBox="0 0 64 64"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.601934524">
                <g id="M端" transform="translate(-127.000000, -3373.000000)" fill="#FFFFFF">
                    <g id="03-icon备份" transform="translate(127.000000, 3373.000000)">
                        <path
                            d="M37.4364062,14.7682532 L58.3974004,49.9527793 C59.5280492,51.850654 58.9060897,54.3057574 57.008215,55.4364062 C56.3890439,55.805274 55.6817135,56 54.9609943,56 L13.0390057,56 C10.8298667,56 9.03900574,54.209139 9.03900574,52 C9.03900574,51.2792807 9.2337317,50.5719504 9.60259957,49.9527793 L30.5635938,14.7682532 C31.6942426,12.8703785 34.149346,12.248419 36.0472207,13.3790677 C36.6185671,13.7194443 37.0960296,14.1969068 37.4364062,14.7682532 Z"
                            id="三角形"
                            transform="translate(34.000000, 32.500000) rotate(90.000000) translate(-34.000000, -32.500000) "
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
